<template>
  <div v-if="noAuth">
    您好，欢迎登录秋分书城~
  </div>
  <div v-else class="wrapper">
  <div class="home">
    <!-- 推荐 -->
    <el-card shadow="hover">
      <div slot="header">
        <span>{{ $t('message.card.title4') }}</span>
        <!--				<el-button class="home-card-more" type="text" @click="onOpenGitee">{{ $t('message.card.title5') }}</el-button>-->
      </div>
      <el-row :gutter="15" class="home-recommend-row">
        <el-col :sm="24" :md="12" :lg="6" :xl="6">
          <div class="home-recommend" :style="{ 'border': '2px solid #F95959','color':'#000000' }">
            <i class="el-icon-user" :style="{ color: '#F86C6B' }"></i>
            <div class="home-recommend-auto">
              <div>今日新用户客单价：<span
                  style="font-size: 20px;font-weight: bold;">{{
                  userCollect.today.new_aov ? userCollect.today.new_aov : 0
                }}</span>
              </div>
              <div class="home-recommend-msg">
                新注册用户充值人数：{{ userCollect.today.new_register_recharge_num ? userCollect.today.new_register_recharge_num : 0 }}
              </div>
              <div class="home-recommend-msg">
                新注册用户充值金额：{{ userCollect.today.new_register_recharge_money ? userCollect.today.new_register_recharge_money : 0}}
              </div>
            </div>
          </div>
        </el-col>
        <el-col :sm="24" :md="12" :lg="6" :xl="6">
          <div class="home-recommend" :style="{ 'border': '2px solid #48D18D','color':'#000000' }">
            <i class="el-icon-data-analysis" :style="{ color: '#64d89d' }"></i>
            <div class="home-recommend-auto">
              <div>今日激活人数：<span
                  style="font-size: 20px;font-weight: bold;">{{
                 userCollect.today.new_active_num ? userCollect.today.new_active_num : 0
                }}</span>
              </div>
              <div class="home-recommend-msg">
                新激活用户充值人数：{{
                  userCollect.today.new_recharge_num ? userCollect.today.new_recharge_num : 0 
                }}
              </div>
              <div class="home-recommend-msg">
                新激活用户充值金额：{{
                  userCollect.today.new_recharge_money ? userCollect.today.new_recharge_money : 0 
                }}
              </div>
            </div>
          </div>
        </el-col>
        
        <el-col :sm="24" :md="12" :lg="6" :xl="6">
          <div class="home-recommend" :style="{ 'border': '2px solid #8595F4','color':'#000000' }">
            <i class="el-icon-data-line" :style="{ color: '#92A1F4' }"></i>
            <div class="home-recommend-auto">
              <div>总充值人数：<span style="font-size: 20px;font-weight: bold;">{{
                  orderCollect.all.recharge_user ? orderCollect.all.recharge_user : 0
                }}</span></div>
              <div class="home-recommend-msg">
                普通充值人数：{{ orderCollect.all.normal_recharge_user ? orderCollect.all.normal_recharge_user : 0 }}
              </div>
              <div class="home-recommend-msg">
                VIP充值人数：{{ orderCollect.all.vip_recharge_user ? orderCollect.all.vip_recharge_user : 0 }}
              </div>
            </div>
          </div>
        </el-col>
        <el-col :sm="24" :md="12" :lg="6" :xl="6">
          <div class="home-recommend" :style="{ 'border': '2px solid #FEBB50','color':'#000000' }">
            <i class="el-icon-coin" :style="{ color: '#FDC566' }"></i>
            <div class="home-recommend-auto">
              <div>总充值金额：<span style="font-size: 20px;font-weight: bold;">{{
                  orderCollect.all.recharge_money_total ? orderCollect.all.recharge_money_total : 0
                }}</span></div>
              <div class="home-recommend-msg">普通充值金额：{{
                  orderCollect.all.normal_recharge_money ? orderCollect.all.normal_recharge_money : 0
                }}
              </div>
              <div class="home-recommend-msg">
                VIP充值金额：{{ orderCollect.all.vip_recharge_money ? orderCollect.all.vip_recharge_money : 0 }}
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <!-- charts -->
    <el-row :gutter="15" class="mt15">
      <el-col :xs="12" :sm="4" :md="4" :lg="4" :xl="4" style="height: 395px">
        <el-card shadow="hover" style="height: 95px">
          <div style="margin-top: -15px">
            <div class="tit tit4">今日充值</div>
            <div class="qian qian4">
              ¥{{ orderCollect.today.recharge_money_total ? orderCollect.today.recharge_money_total : 0 }}
            </div>
          </div>
        </el-card>
        <el-card shadow="hover" style="height: 95px;margin-top: 5px">
          <div style="margin-top: -15px">
            <div class="tit tit4">昨日充值</div>
            <div class="qian qian4">
              ¥{{ orderCollect.yesterday.recharge_money_total ? orderCollect.yesterday.recharge_money_total : 0 }}
            </div>
          </div>
        </el-card>
        <el-card shadow="hover" style="height: 95px;margin-top: 5px">
          <div style="margin-top: -15px">
            <div class="tit tit4">本月充值</div>
            <div class="qian qian4">
              ¥{{ orderCollect.thisMonth.recharge_money_total ? orderCollect.thisMonth.recharge_money_total : 0 }}
            </div>
          </div>
        </el-card>
        <el-card shadow="hover" style="height: 95px;margin-top: 5px">
          <div style="margin-top: -15px">
            <div class="tit tit4">汇总充值</div>
            <div class="qian qian4">
              ¥{{ orderCollect.all.recharge_money_total ? orderCollect.all.recharge_money_total : 0 }}
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :xs="12" :sm="4" :md="4" :lg="4" :xl="4" style="height: 375px">
        <el-card shadow="hover" style="height: 95px">
          <div style="height: 95px;margin-top: -15px">
            <div class="tit tit4">今日激活</div>
            <div class="qian qian4">{{ userCollect.today.new_active_num ? userCollect.today.new_active_num : 0 }}</div>
          </div>
        </el-card>
        <el-card shadow="hover" style="height: 95px;margin-top: 5px">
          <div style="margin-top: -15px">
            <div class="tit tit4">昨日激活</div>
            <div class="qian qian4">{{
                userCollect.yesterday.new_active_num ? userCollect.yesterday.new_active_num : 0
              }}
            </div>
          </div>
        </el-card>
        <el-card shadow="hover" style="height: 95px;margin-top: 5px">
          <div style="margin-top: -15px">
            <div class="tit tit4">本月激活</div>
            <div class="qian qian4">{{
                userCollect.thisMonth.new_active_num ? userCollect.thisMonth.new_active_num : 0
              }}
            </div>
          </div>
        </el-card>
        <el-card shadow="hover" style="height: 95px;margin-top: 5px">
          <div style="margin-top: -15px">
            <div class="tit tit4">汇总激活</div>
            <div class="qian qian4">{{ userCollect.all.new_active_num ? userCollect.all.new_active_num : 0 }}</div>
          </div>
        </el-card>
      </el-col>
      <!-- 图表 -->
      <el-col :xs="24" :sm="16" :md="16" :lg="16" :xl="16">
        <el-card shadow="hover" style="height: 395px">
          <div style="display: flex;justify-content: space-between;">
            <el-radio-group v-model="radio2" size="mini" @change="initHomeLaboratory">
              <span style="margin-right: 10px;">
                <el-radio label="1" border>激活人数</el-radio>
              </span>
              <span style="margin-right: 10px;">
                  <el-radio label="2" border>充值人数</el-radio>
              </span>
              <span style="margin-right: 10px;">
                  <el-radio label="3" border>充值金额</el-radio>
              </span>
            </el-radio-group>

            <el-radio-group v-model="radio3" size="mini" @change="initHomeLaboratory">
              <span style="margin-left: 10px;">
                <el-radio label="1" border>7天</el-radio>
              </span>
              <span style="margin-left: 10px;">
                <el-radio label="2" border>14天</el-radio>
              </span>
              <span style="margin-left: 10px;">
                <el-radio label="3" border>30天</el-radio>
              </span>
            </el-radio-group>
          </div>
          <div class="charts">
            <div class="charts-left mr7">
              <div ref="homeLaboratoryRef" class="h100"></div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 今日/昨日排行 -->
    <el-row :gutter="15" class="mt15">
      <el-col :xs="12" :sm="5" :md="5" :lg="5" :xl="5">
        <el-card :style="{overflow:'visible'}" shadow="hover" style="height: 430px">
          <div class="rank-con home-bg" style="margin-top: 10px">
            <p class="rank-tip"
               style="background: linear-gradient(236deg, rgb(248, 87, 90) 0%, rgb(228, 55, 55) 100%);">今日排行</p>
            <div class="info">
              <ul class="info-ul" v-if="todayMovieRank && todayMovieRank.length>0 " >
                <li v-for="(item,index) in todayMovieRank"
                    style="display: flex;line-height: 40px;height: 40px;cursor: pointer;" :key="index"
                    :class="{ 'info-item': index === selectedIdx && 1 === selectedType  }"
                    @click="selectItem(index,item,1)">
                  <span>{{ index + 1 }}</span>
<!--                  <SvgIcon v-if="index<4" :icon-class="item.icon" class-name="icon" style="height: 25px;width: 16px;"/>-->
<!--                  <span v-if="index>=4">{{ index + 1 }}</span>-->
                  <el-tooltip class="item" effect="dark" :content="item.name" placement="top-end" :open-delay="300">
                    <el-button class="ellipsis" style="width: 100%;text-align: left" type="text">
                      <div class="ellipsis" style="color: #303133">&nbsp;{{ item.name }}</div>
                    </el-button>
                  </el-tooltip>
                  （{{ item.recharge_money }}）
                </li>
              </ul>
              <el-empty v-else :image-size="150"></el-empty>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :xs="12" :sm="5" :md="5" :lg="5" :xl="5">
        <el-card :style="{overflow:'visible'}" shadow="hover" style="height: 430px">
          <div class="rank-con home-bg" style="margin-top: 10px">
            <p class="rank-tip" style="background-color: rgb(249, 169, 96)">昨日排行</p>
            <div class="info">
              <ul class="info-ul" v-if="yesterdayMovieRank && yesterdayMovieRank.length>0 ">
                <li v-for="(item,index) in yesterdayMovieRank"
                    style="display: flex;line-height: 40px;height: 40px;cursor: pointer" :key="index"
                    :class="{ 'info-item': index === selectedIdx && 2===selectedType }"
                    @click="selectItem(index,item,2)">
                  <span>{{ index + 1 }}</span>
<!--                  <SvgIcon v-if="index<4" :icon-class="item.icon" class-name="icon" style="height: 25px;width: 16px;"/>-->
<!--                  <span v-if="index>=4">{{ index + 1 }}</span>-->
                  <el-tooltip class="item" effect="dark" :content="item.name" placement="top-end" :open-delay="300">
                    <el-button class="ellipsis" style="width: 100%;text-align: left" type="text">
                      <div class="ellipsis" style="color: #303133">&nbsp;{{ item.name }}</div>
                    </el-button>
                  </el-tooltip>
                  （{{ item.recharge_money }}）
                </li>
              </ul>
              <el-empty v-else :image-size="150"></el-empty>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :xs="24" :sm="14" :md="14" :lg="14" :xl="14" class="mb15">
        <el-card shadow="hover" style="height: 430px">
          <div class="rank-con home-bg">
            <div  style="display: flex;justify-content: center"><h2>{{currentRankId}}</h2></div>

            <!-- 列表 -->
            <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%;font-size: 12px;margin-top: 10px"
                      size="medium"
                      v-if="tableData && tableData.length > 0"
                      :header-cell-style="{textAlign:'center',background:'#f5f7fa'}" :cell-style="{textAlign:'center'}"
                      border
                      v-loading="loading"
            >
              <el-table-column label="日期">
                <template slot-scope="scope">{{ scope.row.createdate }}</template>
              </el-table-column>
              <!-- <el-table-column prop="name" label="注册人数">
                <template slot-scope="scope">{{ scope.row.add_num }}</template>
              </el-table-column> -->
              <el-table-column prop="name" label="充值人数">
                <template slot-scope="scope">{{ scope.row.recharge_user }}</template>
              </el-table-column>
              <el-table-column prop="name" label="充值金额">
                <template slot-scope="scope">{{ scope.row.recharge_money }}</template>
              </el-table-column>
              <el-table-column prop="name" label="充值笔数">
                <template slot-scope="scope">{{ scope.row.recharge_num }}笔</template>
              </el-table-column>
            </el-table>
            <el-empty :image-size="150" v-else></el-empty>

            <div data-v-60b9ee6c="" class="table-tit table-topTit home-flex" style="color: rgb(153, 153, 153); margin-top: 10px;"><p data-v-60b9ee6c="" class="table-fot-tip">最近7天内数据，包含今日</p></div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import {CountUp} from 'countup.js';
import {Session} from '@/utils/storage';
import {formatAxis, formatDate} from '@/utils/formatTime';
import {recommendList, chartsRightList, newsInfoList, dailyMessage} from './mock';
import {dashboardApi} from '@/api/dashboard/index';
import {SvgIcon} from '@/components/SvgIcon';

export default {
  name: 'home',
  components: {
    SvgIcon
  },
  data() {
    return {
      recommendList,
      chartsRightList,
      newsInfoList,
      // 用户信息
      userInfo: {},
      dailyMessage: {},
      charts: {
        theme: '',
        bgColor: '',
      },
      global: {
        homeChartOne: null,
        homeChartTwo: null,
        homeCharThree: null,
        dispose: [null, '', undefined],
      },
      // 用户统计数据
      userCollect: {
        today: {
          new_register_num: 0, //新注册用户数
          new_dyed_num: 0, //新染色用户数
          new_active_num: 0, //新激活用户数
          new_register_recharge_num: 0, //新注册用户充值人数
          new_register_recharge_money: 0, //新注册用户充值金额
          new_dyed_recharge_num: 0, //新染色用户充值人数
          new_dyed_recharge_money: 0, //新染色用户充值金额
          new_recharge_num: 0, //新激活用户充值人数
          new_recharge_money: 0, //新激活用户充值金额
          recharge_num: 0, //充值总人数
          recharge_money: 0, //充值总金额
          new_register_recharge_bnum: 0, //新注册用户充值笔数
          new_recharge_bnum: 0 //新激活用户充值笔数
        },
        yesterday: {
          new_register_num: 0, //新注册用户数
          new_dyed_num: 0, //新染色用户数
          new_active_num: 0, //新激活用户数
          new_register_recharge_num: 0, //新注册用户充值人数
          new_register_recharge_money: 0, //新注册用户充值金额
          new_dyed_recharge_num: 0, //新染色用户充值人数
          new_dyed_recharge_money: 0, //新染色用户充值金额
          new_recharge_num: 0, //新激活用户充值人数
          new_recharge_money: 0, //新激活用户充值金额
          recharge_num: 0, //充值总人数
          recharge_money: 0, //充值总金额
          new_register_recharge_bnum: 0, //新注册用户充值笔数
          new_recharge_bnum: 0 //新激活用户充值笔数
        },
        thisMonth: {
          new_register_num: 0, //新注册用户数
          new_dyed_num: 0, //新染色用户数
          new_active_num: 0, //新激活用户数
          new_register_recharge_num: 0, //新注册用户充值人数
          new_register_recharge_money: 0, //新注册用户充值金额
          new_dyed_recharge_num: 0, //新染色用户充值人数
          new_dyed_recharge_money: 0, //新染色用户充值金额
          new_recharge_num: 0, //新激活用户充值人数
          new_recharge_money: 0, //新激活用户充值金额
          recharge_num: 0, //充值总人数
          recharge_money: 0, //充值总金额
          new_register_recharge_bnum: 0, //新注册用户充值笔数
          new_recharge_bnum: 0 //新激活用户充值笔数
        },
        all: {
          new_register_num: 0, //新注册用户数
          new_dyed_num: 0, //新染色用户数
          new_active_num: 0, //新激活用户数
          new_register_recharge_num: 0, //新注册用户充值人数
          new_register_recharge_money: 0, //新注册用户充值金额
          new_dyed_recharge_num: 0, //新染色用户充值人数
          new_dyed_recharge_money: 0, //新染色用户充值金额
          new_recharge_num: 0, //新激活用户充值人数
          new_recharge_money: 0, //新激活用户充值金额
          recharge_num: 0, //充值总人数
          recharge_money: 0, //充值总金额
          new_register_recharge_bnum: 0, //新注册用户充值笔数
          new_recharge_bnum: 0 //新激活用户充值笔数
        }
      },
      // 订单统计数据
      orderCollect: {
        today: {
          normal_recharge_user: null, //普通充值人数
          normal_recharge_orders_num: null, //普通充值订单数
          normal_recharge_orders_suc_num: null, //普通充值订单成功数
          normal_recharge_money: null, //普通充值订单金额
          normal_recharge_money_benefit: null, //普通充值渠道分成收益
          vip_recharge_user: null, //VIP充值人数
          vip_recharge_orders_num: null, //VIP充值订单数
          vip_recharge_orders_suc_num: null, //VIP充值订单成功数
          vip_recharge_money: null, //VIP充值订单金额
          vip_recharge_money_benefit: null, //VIP充值渠道分成收益
          recharge_user: null, //充值总人数
          recharge_orders_total_num: null, //充值订单总数
          recharge_orders_total_suc_num: null, //充值订单总成功数
          recharge_money_total: null, //充值订单总金额
          recharge_money_total_benefit: null //充值订单渠道分成总收益
        },
        yesterday: {
          normal_recharge_user: null, //普通充值人数
          normal_recharge_orders_num: null, //普通充值订单数
          normal_recharge_orders_suc_num: null, //普通充值订单成功数
          normal_recharge_money: null, //普通充值订单金额
          normal_recharge_money_benefit: null, //普通充值渠道分成收益
          vip_recharge_user: null, //VIP充值人数
          vip_recharge_orders_num: null, //VIP充值订单数
          vip_recharge_orders_suc_num: null, //VIP充值订单成功数
          vip_recharge_money: null, //VIP充值订单金额
          vip_recharge_money_benefit: null, //VIP充值渠道分成收益
          recharge_user: null, //充值总人数
          recharge_orders_total_num: null, //充值订单总数
          recharge_orders_total_suc_num: null, //充值订单总成功数
          recharge_money_total: null, //充值订单总金额
          recharge_money_total_benefit: null //充值订单渠道分成总收益
        },
        thisMonth: {
          normal_recharge_user: null, //普通充值人数
          normal_recharge_orders_num: null, //普通充值订单数
          normal_recharge_orders_suc_num: null, //普通充值订单成功数
          normal_recharge_money: null, //普通充值订单金额
          normal_recharge_money_benefit: null, //普通充值渠道分成收益
          vip_recharge_user: null, //VIP充值人数
          vip_recharge_orders_num: null, //VIP充值订单数
          vip_recharge_orders_suc_num: null, //VIP充值订单成功数
          vip_recharge_money: null, //VIP充值订单金额
          vip_recharge_money_benefit: null, //VIP充值渠道分成收益
          recharge_user: null, //充值总人数
          recharge_orders_total_num: null, //充值订单总数
          recharge_orders_total_suc_num: null, //充值订单总成功数
          recharge_money_total: null, //充值订单总金额
          recharge_money_total_benefit: null //充值订单渠道分成总收益
        },
        all: {
          normal_recharge_user: null, //普通充值人数
          normal_recharge_orders_num: null, //普通充值订单数
          normal_recharge_orders_suc_num: null, //普通充值订单成功数
          normal_recharge_money: null, //普通充值订单金额
          normal_recharge_money_benefit: null, //普通充值渠道分成收益
          vip_recharge_user: null, //VIP充值人数
          vip_recharge_orders_num: null, //VIP充值订单数
          vip_recharge_orders_suc_num: null, //VIP充值订单成功数
          vip_recharge_money: null, //VIP充值订单金额
          vip_recharge_money_benefit: null, //VIP充值渠道分成收益
          recharge_user: null, //充值总人数
          recharge_orders_total_num: null, //充值订单总数
          recharge_orders_total_suc_num: null, //充值订单总成功数
          recharge_money_total: null, //充值订单总金额
          recharge_money_total_benefit: null //充值订单渠道分成总收益
        }
      },
      // 统计排行参数
      movieRankForm: {
        pageNo: 1,
        pageSize: 10,
        sort: "recharge_money",
        sortType: "desc"
      },
      // 今日排行
      todayMovieRank: [],
      // 昨日排行
      yesterdayMovieRank: [],
      // 1 激活人数 2 充值人数 3 充值金额
      radio2: '1',
      radios: [
        {label: '1', text: '激活人数', field: 'new_active_num'},
        {label: '2', text: '充值人数', field: 'recharge_user'},
        {label: '3', text: '充值金额', field: 'recharge_money_total'},
      ],
      // 1 7天 2 14天 3 30天
      radio3: '1',
      radio3s: [
        {label: '1', text: '7天', value: 7},
        {label: '2', text: '14天', value: 14},
        {label: '3', text: '30天', value: 30},
      ],
      // 首页排行统计表格
      tableData: [],
      // 当前选中的排行索引
      selectedIdx: -1,
      // 当前选中的排行类型
      selectedType: 1,
      // 当前选中的小说
      currentRankId: null,
      loading: true,//加载状态
      roleId: 0
    };
  },
  created() {
    // 初始化用户登录信息
    this.initUserInfo();
    // 初始化用户登录提示语
    this.initDailyMessage();
  },
  computed: {
    noAuth(){
      return this.roleId == 6 || this.roleId == 7
    },
    currentTime() {
      return formatAxis(new Date());
    },
    optionSingleHeight() {
      return {
        singleHeight: 28,
        limitMoveNum: 8,
        waitTime: 2000,
      };
    },
    getUserInfos() {
      return this.$store.state.userInfos.userInfos;
    },
  },
  mounted() {
    this.roleId = Session.get('roleId')
    if(this.noAuth) return
    // 初始化用户统计信息
    this.initUserCollectList();
    // 初始化订单统计信息
    this.initOrderCollectList();
    // 初始化柱状统计图
    this.initHomeLaboratory();
    // 初始化排行统计数据
    this.initHomeRank();
  },
  methods: {

    // 点击左侧排行 获取对应近7天数据
    selectItem(index, item, type) {
      this.selectedIdx = index;
      this.selectedType = type;
      this.currentRankId = item.name +" ("+ item.id + ")";
      let param = {
        pageNo: 1,
        pageSize: 7,
        id: item.id
      }
      this.loading = true;
      let api = dashboardApi()
      api.moviesCollectRankingsList(param).then(res => {
        this.tableData = res.data.data;
        this.loading = false;
      })
    },
    // 小说排行
    initHomeRank() {
      let api = dashboardApi()
      api.moviesCollectRank(this.movieRankForm).then(res => {
        this.todayMovieRank = res.data.today;

        this.todayMovieRank.forEach((item,index) => {
          item.icon = this.getIcon(index);
        })

        this.yesterdayMovieRank = res.data.yesterday;
        // 如果今日排行有数据 默认选中今日排行第一条数据
        if (res.data.today && res.data.today.length > 0){
          this.selectItem(0, res.data.today[0], 1);
        }
      })
    },

    getIcon(item){
      let name = item+1;
      if(item<4){
        return 'jiangpai-'+name;
      }else{
        return name;
      }
    },
    // 用户统计数据
    initUserCollectList() {
      let api = dashboardApi()
      api.userCollectList().then(res => {
        this.userCollect = res.data;
      })
    },
    // 用户统计数据
    initOrderCollectList() {
      let api = dashboardApi()
      api.orderCollectList().then(res => {
        this.orderCollect = res.data;
      })
    },
    // 激活/充值图表
    initHomeLaboratory() {
      if (!this.global.dispose.some((b) => b === this.global.homeChartTwo)) this.global.homeChartTwo.dispose();
      this.global.homeChartTwo = echarts.init(this.$refs.homeLaboratoryRef, this.charts.theme);

      // 名称
      const name = this.radios.find(radio => radio.label === this.radio2).text;
      const field = this.radios.find(radio => radio.label === this.radio2).field;
      const day = this.radio3s.find(radio => radio.label === this.radio3).value;
      dashboardApi().indexChart(day).then(res => {
        const option = {
          backgroundColor: this.charts.bgColor,
          grid: {
            top: 50,
            right: 20,
            bottom: 30,
            left: '7%'
          },
          tooltip: {
            trigger: 'axis',
          },
          legend: {
            data: [name],
            right: 13,
          },
          xAxis: {
            data: res.data.xAxis,
          },
          yAxis: [
            {
              type: 'value',
              name: '',
            },
          ],
          series: [
            {
              name: name,
              type: 'bar',
              data: res.data[field],
            }
          ],
        };
        this.global.homeChartTwo.setOption(option);
        window.addEventListener('resize', () => {
          this.global.homeChartTwo.resize();
        });
      })
    },
    // 初始化数字滚动
    initNumCountUp() {
      this.$nextTick(() => {
        new CountUp('titleNum1', Math.random() * 100000).start();
        new CountUp('titleNum2', Math.random() * 100000).start();
        new CountUp('titleNum3', Math.random() * 100000).start();
      });
    },
    // 随机语录
    initDailyMessage() {
      this.dailyMessage = dailyMessage[Math.floor(Math.random() * dailyMessage.length)];
    },
    // 初始化登录信息
    initUserInfo() {
      if (!Session.get('userInfo')) return false;
      this.userInfo = Session.get('userInfo');
      this.userInfo.time = formatDate(new Date(this.userInfo.time), 'YYYY-mm-dd HH:MM:SS');
    },
    // 消息通知当前项点击
    onNewsInfoListClick(v) {
      window.open(v.link);
    },
    // 跳转到 gitee
    onOpenGitee() {
      window.open('https://gitee.com/lyt-top/vue-next-admin');
    }
  },
  watch: {
    // 监听 vuex 数据变化
    '$store.state.themeConfig.themeConfig.isIsDark': {
      handler(isIsDark) {
        this.$nextTick(() => {
          this.charts.theme = isIsDark ? 'dark' : '';
          this.charts.bgColor = isIsDark ? 'transparent' : '';
        });
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped lang="scss">
@import './index.scss';

.rank-con {
  position: relative;
  .rank-tip {
    position: absolute;
    left: 50%;
    top: -40px;
    margin-left: -50px;
    width: 100px;
    height: 33px;
    text-align: center;
    line-height: 30px;
    border-radius: 17px;
    font-size: 15px;
    font-weight: 500;
    color: #fff
  }

}

.tit {
  font-size: 18px;
  margin-top: 12px;
}

.tit4 {
  margin-top: 10px !important;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis
}

.qian4 {
  line-height: 35px !important;
  margin-top: 10px !important
}

.qian {
  font-size: 20px;
  font-weight: 700;
  margin-top: 10px;
  color: #000
}

.rank-item0 {
  color: #e53939
}

.info-item {
  background-color: #f8f9fc;
  //font-size: 43px;
  border-radius: 10px;
  //color: red;
}
.ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
